export const TITLE = 'Company Information';

export const CLASS_NAMES = {
  title: 'text-16-20-em text-neutral-900',
};
